import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getServiceDetails } from "../../helpers/http_services_requests";
import { useQuery } from "@tanstack/react-query";
import { centsToReais } from "../../utils/functions";

export default function ServiceDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getServiceDetails', id], 
        queryFn: () => getServiceDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: serviceData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Serviço - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "price",
                    label: "Preço",
                    type: "text",
                    mask: "currency",
                    required: true
                },
            ]
        },
    ];

    return <DynamicFormPage 
        isLoading={isFetching} 
        details 
        initialData={serviceData ? { ...serviceData, price: centsToReais(serviceData.price) } : serviceData} 
        title={"Serviço - Detalhes"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
    />;
}
